import React, { SVGProps } from "react";

const SvgRoof2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof002 dims 1">
      <path
        fill="#b2c4d0"
        d="M124.085 186.528v30.818l160.241-92.618V93.911l-160.241 92.617z"
      />
      <path
        fill="#fff"
        d="M124.085 186.528v30.818l-91.408-52.651v-40.374l41.086-16.655 50.322 78.862z"
      />
      <path
        fill="#b2c4d0"
        d="M209.284 173.143v34.867l59.068-34.205v-39.23l-27.645-5.426-31.423 43.994z"
      />
      <path
        fill="#fff"
        d="M209.284 173.143v34.867l-34.547-19.941v-39.23l34.547 24.304z"
      />
      <g fill="#6d9faf">
        <path d="M77.283 127.792v9.221l-7.666-4.416v-9.221l7.666 4.416zM86.674 133.214v9.221l-7.666-4.416v-9.221l7.666 4.416zM77.283 138.836v9.221l-7.666-4.416v-9.221l7.666 4.416zM86.674 144.257v9.221l-7.666-4.416v-9.221l7.666 4.416z" />
      </g>
      <path
        fill="#2176a8"
        d="m293.553 88.458-169.468 98.07-50.786-78.61 169.84-97.996 50.414 78.536z"
      />
      <path
        fill="#47d5ff"
        d="m243.139 9.922-169.84 97.996-49.955 20.209 169.701-98.078 50.094-20.127z"
      />
      <path
        fill="#2682b5"
        d="m182.996 97.025 61.287 19.945 33.418 19.197-34.505-4.56-60.2-34.582z"
      />
      <path
        fill="#47e2ff"
        d="m182.996 97.025-8.645 60.415 34.543 18.894 34.302-44.727-60.2-34.582z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M124.085 186.528v30.818M174.737 157.467v30.602M209.284 208.01v-32.194"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M32.677 124.321v40.374l91.408 52.651 50.652-29.277 34.547 19.941 59.068-34.205v-39.23M271.087 132.436l13.239-7.708V93.911"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="M73.644 107.286 243.139 9.922M243.196 131.607l-60.2-34.582"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m174.351 157.44-50.266 29.088-50.786-78.61-49.955 20.209 169.701-98.078 50.094-20.127 50.414 78.536-49.27 28.512 33.418 19.197-34.505-4.56-34.302 44.727-34.543-18.894z"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="m244.283 116.97-61.287-19.945-8.645 60.415"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m101.404 230.809 17.604-10.175M10 178.16l17.561-10.214M14.274 175.67l125.825 72.522" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m163.207 234.847 40.612-23.454M135.807 250.671l18.131-10.471" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m231.468 221.283-17.604-10.175M290.677 187.222l-17.561-10.214" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m180.679 250.356-50.504-29.17M336.673 155.458l-160.286 92.418" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m341.187 157.687-44.8-25.877M290.557 128.455l-3.928-2.279" />
      </g>
      <text
        transform="translate(201.95 245.293)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <text
        transform="translate(20.212 104.96)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <text
        transform="translate(300.448 127.271)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <text
        transform="translate(259.196 214.596)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <text
        transform="translate(312.608 184.16)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"E"}
      </text>
      <text
        transform="translate(111.926 250.92)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(48.78 215.749)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M14.279 171.672v8M105.651 224.426v8M140.099 244.315v8M176.385 243.884v8M226.952 214.69v8M286.165 180.503v8M337.085 151.105v8M26.614 126.925C17.303 108.982 11.774 89.58 11.7 72.25M68.33 104.924 6.191 69.036M302.971 96.373l-55.918 32.161M15.175 70.24l-6.929 4M27.536 123.067l-1.809 7.793M301.848 100.589l-6.929-4M291.348 141.731l-2.078-7.726M290.43 137.941c5.41-13.226 8.443-26.835 8.334-39.216M294.627 138.38l-13.245-1.761"
      />
    </g>
  </svg>
);

export default SvgRoof2;
